/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Session_EndsInputs */

const th_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิ้นสุด`)
};

const en_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ends`)
};

const ja_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了`)
};

const zh_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结束`)
};

const es_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termina`)
};

const pt_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termina`)
};

const id_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berakhir`)
};

const fr_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin`)
};

const tl_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagtatapos`)
};

const vi_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kết thúc`)
};

const ko_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`종료`)
};

const de_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endet`)
};

const ru_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заканчивается`)
};

const tr_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitiş`)
};

const it_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fine`)
};

const pl_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koniec`)
};

const uk_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершення`)
};

const hi_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समाप्ति`)
};

const ar_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنتهي`)
};

const ms_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamat`)
};

const bn_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শেষ`)
};

const zh_tw2_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結束`)
};

const zh_hk2_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結束`)
};

const ur_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختتام`)
};

const fa_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پایان`)
};

const sw_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinaisha`)
};

const nl_event_session_ends = /** @type {(inputs: Event_Session_EndsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eindigt`)
};

/**
* | output |
* | --- |
* | "Ends" |
*
* @param {Event_Session_EndsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_session_ends = /** @type {((inputs?: Event_Session_EndsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Session_EndsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_session_ends(inputs)
	if (locale === "ja") return ja_event_session_ends(inputs)
	if (locale === "zh") return zh_event_session_ends(inputs)
	if (locale === "es") return es_event_session_ends(inputs)
	if (locale === "pt") return pt_event_session_ends(inputs)
	if (locale === "id") return id_event_session_ends(inputs)
	if (locale === "fr") return fr_event_session_ends(inputs)
	if (locale === "tl") return tl_event_session_ends(inputs)
	if (locale === "vi") return vi_event_session_ends(inputs)
	if (locale === "ko") return ko_event_session_ends(inputs)
	if (locale === "de") return de_event_session_ends(inputs)
	if (locale === "ru") return ru_event_session_ends(inputs)
	if (locale === "tr") return tr_event_session_ends(inputs)
	if (locale === "it") return it_event_session_ends(inputs)
	if (locale === "pl") return pl_event_session_ends(inputs)
	if (locale === "uk") return uk_event_session_ends(inputs)
	if (locale === "hi") return hi_event_session_ends(inputs)
	if (locale === "ar") return ar_event_session_ends(inputs)
	if (locale === "ms") return ms_event_session_ends(inputs)
	if (locale === "bn") return bn_event_session_ends(inputs)
	if (locale === "zh-TW") return zh_tw2_event_session_ends(inputs)
	if (locale === "zh-HK") return zh_hk2_event_session_ends(inputs)
	if (locale === "ur") return ur_event_session_ends(inputs)
	if (locale === "fa") return fa_event_session_ends(inputs)
	if (locale === "sw") return sw_event_session_ends(inputs)
	if (locale === "nl") return nl_event_session_ends(inputs)
	return en_event_session_ends(inputs)
});